// extracted by mini-css-extract-plugin
export default {"card":"ImageCardBody_card__tKuPM","infoWrapper":"ImageCardBody_infoWrapper__aRMEN"};